import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTipoObra = '/service/materiais/obras/'

class TipoObraService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getTipoObra() {
        return this.conex.get(urlTipoObra + 'todos/')
    }
}

export default TipoObraService
